import axios from 'axios';

import { BASE_HOST_URL } from '../config';

let baseURL = BASE_HOST_URL;
if (process.env.NODE_ENV === 'development') {
  baseURL = 'http://localhost:3005';
}

export function getRooms() {
  return axios.get(`${baseURL}/api/v1/rooms`);
}

export function getRoomById(roomId) {
  return axios.get(`${baseURL}/api/v1/rooms/${roomId}`);
}

export function updateMaxOpeningDate(roomId, date) {
  return axios.put(`${baseURL}/api/v1/rooms/${roomId}`, { date });
}

export function savePrice(roomId, prices) {
  return axios.put(`${baseURL}/api/v1/rooms/${roomId}/prices`, { prices });
}

export function getRoomPrices(roomId) {
  return axios.get(`${baseURL}/api/v1/rooms/${roomId}/prices`);
}

export function setPrices(month, flag) {
  return axios.post(`${baseURL}/api/v1/prices`, { month, flag });
}

export function getPrices(month, flag) {
  return axios.get(`${baseURL}/api/v1/prices`);
}

export function setSpecialDays(day) {
  return axios.post(`${baseURL}/api/v1/prices/specialdays`, day);
}

export function getSpecialDays() {
  return axios.get(`${baseURL}/api/v1/prices/specialdays`);
}

export function deleteSpecialDay(day) {
  return axios.put(`${baseURL}/api/v1/prices/specialdays`, day);
}

export function getRoomPriceByHostagesAndDates(roomId, data) {
  return axios.post(`${baseURL}/api/v1/rooms/${roomId}/prices`, data);
}



// WEBPACK FOOTER //
// ./src/services/rooms.js